'use strict';

var _extends = require('./extends-f8003900.js');
var objectWithoutProperties = require('./objectWithoutProperties-aa43106a.js');
var React = require('react');
var index = require('./index-0e40e0c2.js');
var components_NuDSProvider_NuDSProvider = require('./components/NuDSProvider/NuDSProvider.js');
var utils_ref_refType = require('./utils/ref/refType.js');
var utils_intl_intlAriaAttrs = require('./utils/intl/intlAriaAttrs.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function withIntlAriaAttrs(Component) {
  var EnhancedComponent = function EnhancedComponent(props) {
    var intlAriaKey = props.intlAriaKey,
        forwardedRef = props.forwardedRef,
        otherProps = objectWithoutProperties.objectWithoutProperties(props, ["intlAriaKey", "forwardedRef"]);

    var nudsContext = React.useContext(components_NuDSProvider_NuDSProvider.NuDsContext);
    return /*#__PURE__*/React__default['default'].createElement(Component, _extends._extends({}, utils_intl_intlAriaAttrs['default'](nudsContext, intlAriaKey), otherProps, {
      ref: forwardedRef
    }));
  };

  EnhancedComponent.defaultProps = {
    forwardedRef: undefined,
    intlAriaKey: ''
  };
  EnhancedComponent.propTypes = {
    forwardedRef: utils_ref_refType['default'],
    intlAriaKey: index.PropTypes.string
  };

  function forwardRef(props, ref) {
    return /*#__PURE__*/React__default['default'].createElement(EnhancedComponent, _extends._extends({}, props, {
      forwardedRef: ref
    }));
  }

  var name = Component.displayName || Component.name;

  if (name) {
    forwardRef.displayName = "withIntlAriaAttrs(".concat(name, ")");
  }

  return /*#__PURE__*/React__default['default'].forwardRef(forwardRef);
}

exports.withIntlAriaAttrs = withIntlAriaAttrs;
//# sourceMappingURL=withIntlAriaAttrs-d03681b9.js.map
